import posthog from 'posthog-js';

import { isPostHogEnabled } from '../config';

export const capture = (event, properties) => {
  if (!isPostHogEnabled) {
    return;
  }

  posthog.capture(event, properties);
};

export const identify = (distinctId, properties) => {
  if (!isPostHogEnabled || !distinctId) {
    return;
  }

  posthog.identify(distinctId, properties);
};

export const reset = () => {
  if (!isPostHogEnabled) {
    return;
  }

  posthog.reset();
};
